<template>
  <section class="base-header-sec base-header-laen  laen">
    <div class="base-header__top-line laen"></div>
    <div class="container-fluid">
      <div class=" container-lg  base-header__container ">
        <div
          class="inner ml-lg-5 d-flex justify-content-between align-items-center"
        >
          <h2 class="base-header__title mob d-block d-lg-none">
            {{ headerName }}
          </h2>
          <ul class="nav ">
            <li class="nav-item ">
              <router-link
                class="nav-link"
                :to="{ path: '/pp-content/' + extCode }"
                >Садржај</router-link
              >
            </li>
            <li class="nav-item ">
              <router-link
                class="nav-link"
                :to="{ path: '/pp-latest/' + extCode }"
                id="tab-svi-brojevi"
                >Најновије</router-link
              >
            </li>
            <li class="nav-item ">
              <router-link
                class="nav-link"
                :to="{ path: '/pp-search/' + extCode }"
                >Претрага</router-link
              >
            </li>

            <li class="nav-item ">
              <router-link
                class="nav-link "
                :to="{
                  path: '/pp-static/' + extCode,
                  query: { page: 'contact' },
                }"
              >
                Контакт
              </router-link>
            </li>
            <li class="nav-item ">
              <router-link
                class="nav-link "
                :to="{
                  path: '/pp-static/' + extCode,
                  query: { page: 'impresum' },
                }"
              >
                Импресум
              </router-link>
            </li>
          </ul>
          <h1 class="base-header__title d-none d-lg-block">
            {{ headerName }}
          </h1>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PpBaseHeaderSec",
  data() {
    return {
      extCode: "",
      headerName: "",
    };
  },
  mounted() {
    this.renderPackagesByExtCode();
  },
  watch: {
    $route() {
      this.renderPackagesByExtCode();
    },
  },
  methods: {
    renderPackagesByExtCode() {
      switch (this.$route.params.extCode) {
        case "WPP_ESZLJP_GUIDE":
          this.headerName = "Водич кроз пресуде Европског суда за људска права";
          this.extCode = this.$route.params.extCode;
          break;
        case "WPP_KD":
          this.headerName = "Кривична дела у судској пракси";
          this.extCode = this.$route.params.extCode;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped></style>
